import { InjectionToken } from '@angular/core';

import { EnvironmentConfig } from '../models';

export const APP_ENVIRONMENT = new InjectionToken<EnvironmentConfig>('APP_ENVIRONMENT');
